/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';

import { styled } from "@mui/system";
import CustomButton from "../../components/buttons/CustomButton";
import styles from "./popup.module.css";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    "&.MuiTableCell-head": {
        fontFamily: "Unilever Shilling",
        color: "#fff",
        textAlign: "center",
        padding: "5px",
        fontSize: "12px",
        fontWeight: 600,
        borderTop: "1px solid #EAECF0",
        // borderRight: "1px solid #EAECF0",
        borderBottom: "1px solid #EAECF0",
        borderLeft: "1px solid #EAECF0",
        whiteSpace: "nowrap",
    },
    "&.MuiTableCell-body": {
        fontFamily: "Unilever Shilling",
        fontSize: "12px",
        fontWeight: 400,
        padding: "5px",
        color: "#2B2B2B",
        borderTop: "1px solid #EAECF0",
        // borderRight: "1px solid #EAECF0",
        borderBottom: "1px solid #EAECF0",
        // borderLeft: "1px solid #EAECF0",
        textAlign: "center",
        whiteSpace: "nowrap",
    },
}));

const StyledTableRow = styled(TableRow)({
    backgroundColor: "#FFFFFF !important"
});

const getRowKey = (row) => {
    const primary = row?.id ?? row?.["Vendor ID"] ?? row?.["Material Id"] ?? JSON.stringify(row);
    return String(primary);
};

const SupplierPopup = ({ type, tableData, handleAlertPopup}) => {
    return (
        <Modal open={Boolean(type)} onClose={handleAlertPopup}>
            <div className={styles.modalContainer}>
                <div className={styles.dialogBox} style={{ width: "95%", height: "90%" }}>
                    {tableData.length === 0 ? (
                        <Typography className={styles.subHeader} sx={{ textAlign: 'center', marginTop: '10px' }}>
                            {"No Supplier details available for this Material"}
                        </Typography>
                    ) : (
                        <TableContainer className={styles.table} style={{maxHeight:'fit-content'}}>
                            <Table size="small" >
                                <TableHead sx={{ position: 'sticky', top: 0, zIndex: 999 }}>
                                    <TableRow sx={{ backgroundColor: "var(--primany-table-header-color)" }}>
                                        {Object.keys(tableData[0]).map((col) => (
                                            <StyledTableCell key={`header-${col}`}>
                                                <div>{col}</div>
                                            </StyledTableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {tableData.map((row) => {
                                        const rowKey = getRowKey(row);
                                        return (
                                        <StyledTableRow key={`row-${rowKey}`}>
                                            {Object.keys(row).map((col) => (
                                                <StyledTableCell key={`cell-${rowKey}-${col}`} sx={{ border: "1px solid #EAECF0" }}>
                                                    <div>{row[col]}</div>
                                                </StyledTableCell>
                                            ))}
                                        </StyledTableRow>
                                    )})}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                    <div className={`${styles.dialogBtn} ${styles.cancelBtn}`}>
                        <CustomButton label="Close" type="reject" onClick={handleAlertPopup} />
                    </div>
                </div>
            </div>
        </Modal>
    );
};

SupplierPopup.propTypes = {
    handleAlertPopup: PropTypes.func.isRequired,
    type: PropTypes.string,
    tableData: PropTypes.arrayOf(PropTypes.object),
};

export default SupplierPopup;